export const PRODUCT_URL = 'SIGNUP_PRODUCT_URL';
export const TEST_USER_AGENT = 'Testzilla';
